export const dashboardTabs = {
  ACTIVITY_WEEK: 'activity_week',
  ACTIVITY: 'activity',
  IDEAS: 'ideas',
  PEOPLE: 'people',
  PRIVATE_IDEAS: 'privateIdeas',
}

export const typesViewAs = {
  QUADRANT: 0,
  GRID: 1,
  LIST: 2,
}
